'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:ForgotPasswordCtrl
 * @description
 * # ForgotPasswordCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp')
  .controller('ForgotPasswordCtrl', ['$scope','$location','Session',function ($scope,$location,Session) {
      $scope.email='';
      $scope.successMsg='';
      $scope.errMsg='';
      $scope.processing = false;

      $scope.forgotPassword = function (email) {
          $scope.successMsg = '';
          $scope.errMsg = '';
          $scope.processing = true;

          Session.forgotPassword(email).then(function (msg) {
              if (msg.data) {
                  $scope.errMsg = '';
                  $scope.successMsg = email + ' will receive an email containing instructions of how to reset their CIMER account\'s password';
              } else {
                  $scope.successMsg = '';
                  $scope.errMsg = 'Error: Please use the email that you set up your account with.';
              }
              $scope.processing = false;
        }, function(){
          $scope.successMsg='';
          $scope.errMsg='An error occurred, please try again';
          $scope.processing = false;
        });
      };

  }]);
